import { getConfigTenant, getConfigClientType } from "@capone/common";

// Use process.env when running Pawtucket modules on their own, otherwise use runtime config from McLean
export const BASE_URL = window.__mclean_env__
  ? window.__mclean_env__.REACT_APP_TYSONS_URL
  : "";

const TENANT = getConfigTenant();
const CHANNEL = getConfigClientType();
const CLIENT_TYPE = getConfigClientType();

export const config = {
  apiKey: "test",
  baseURL: BASE_URL!,
  TENANT,
  CHANNEL,
  CLIENT_TYPE,
};
